module.exports = __webpack_public_path__ + "static/media/diners.48148d1d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/payment-icons/min/single/diners.svg
// module id = 491
// module chunks = 0